(() => {
  const synchronize = () => {
    document.documentElement.classList.toggle('reaze-signup-in-view', Boolean(document.querySelector('.reaze-signup.is-in-view')));
  };
  const initialize = (section) => {
    if (section.dataset.signupInitialized) return;
    section.dataset.signupInitialized = 'true';
    const observer = new IntersectionObserver(([entry]) => {
      section.classList.toggle('is-in-view', entry.isIntersecting);
      synchronize();
    }, { rootMargin: '-70px 0px 0px 0px' });
    observer.observe(section);
    const cleanup = (event) => {
      if (!event.target.contains(section)) return;
      observer.disconnect();
      section.classList.remove('is-in-view');
      delete section.dataset.signupInitialized;
      synchronize();
      document.removeEventListener('shopify:section:unload', cleanup);
    };
    document.addEventListener('shopify:section:unload', cleanup);
  };
  document.querySelectorAll('.reaze-signup').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.reaze-signup').forEach(initialize);
  });
})();
